import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";
import Recaptcha from "../Features/Recaptcha";
import BridgeEvents from "../Features/BridgeEvents";

function FormOpen(props){

    const [formError, setFormError] = useState(false);
    const [formErrorText, setFormErrorText] = useState("");
    const [recaptchaSuccess, setRecaptchaSuccess] = useState(props.isCaptchaProtected ? "" : "not protected");

    const {
        register,
        handleSubmit,
        formState: { errors , isDirty, submitCount}
    } = useForm({
        defaultValues: {
            terms: false,
            communications: false,
        },

    });

    useEffect(()=>{
        window.disableHeightAdjustment = false;
        if(isDirty){
            BridgeEvents.FormStarted();
        }
        if(Object.keys(errors).length > 0){
            BridgeEvents.FormError(submitCount);
        }
    });
    const onSubmit = (data) => {
        let submission = {
            recaptchaToken: recaptchaSuccess,
            formName: props.formName,
            formData: data,
        };

        const baseUrl = process.env.REACT_APP_API_BASE_PATH || "https://pgaoaroster-staging.sportstechapp.com"
        const submitUrl = `${baseUrl}/api/v1/pgaoaroster/forms/submit.json`
        fetch(submitUrl, {
            method: "POST",
            body: JSON.stringify(submission),
            headers: {
                "content-type": "application/json",
            }
        }).then((response)=> {
            try {
                return response.json();
            }catch(e){
                if (!response.ok && !props.ignoreNetworkError) {
                    throw new Error('Error submitting form (' + response.status + ")");
                }
            }
        }).then((data) => {
            if('errors' in data){
                throw new Error(data.errors[0]);
            }
            BridgeEvents.FormFinished();
            props.debugSetter(JSON.stringify(submission, "", 2));
            props.submittedSetter(true);
        }).catch((error)=>{
            setFormError(true);
            setFormErrorText(error.message);
        });
    };

    const PassedForm = props.form;

    return <div className={"p-8 md:p-12"}>
        {props.formHeader}
        <hr className={"w-80 border-yellow-500 mb-6 border-t-4"} />
        <form onSubmit={handleSubmit(onSubmit)}>


            <PassedForm errors={errors} register={register}></PassedForm>

            {props.isCaptchaProtected && <div className={"mt-4"}>
                <Recaptcha callback={setRecaptchaSuccess}></Recaptcha>
            </div> }

            <input type={"submit"} value={"Submit"} className={
                recaptchaSuccess ? "text-white block active:bg-gray-700 p-3 pl-8 pr-8 rounded-3xl border-white border-2 mt-4" :
                    "text-gray-600 block p-2 pl-10 pr-10 rounded-3xl border-gray-600 border-2 mt-4"
            } disabled={!recaptchaSuccess} />

            <div className={"pt-10 text-[10px]"}>{props.disclaimerText}</div>

            {formError && <div className={"border-red-500 border mt-6 text-red-500 p-5 "}>Could not submit: {formErrorText}</div>}
            {isDirty && <div className={"h-0.5"}></div>}
        </form>
    </div>;
}

export default FormOpen;
